import React, { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Stack } from '@lyearn/ui';
import { ContentEntity, DueDateNestingLevelEnum, PathSectionType } from '@/types/schema';

import { RenderDueDate } from '../../renderer';
import { AdaptedNestedDueDateConfig } from '../ContentAndCollectionList/hooks/useContentAndCollectionList';
import ChildResource from './ChildResource';
import SectionDetails from './SectionDetails';

interface SectionProps {
  section: PathSectionType;
  dueDateNestingLevel: DueDateNestingLevelEnum;
  onSetDueDateForContent: (
    content: ContentEntity,
    dueDateNestingLevel?: DueDateNestingLevelEnum | undefined,
    isNested?: boolean,
  ) => void;
  onSetDueDateForSection: (
    section: PathSectionType,
    dueDateNestingLevel?: DueDateNestingLevelEnum | undefined,
    isNested?: boolean,
  ) => void;
  nestedDueDateConfig: AdaptedNestedDueDateConfig;
  className?: string;
}

function Section(props: SectionProps) {
  const { t } = useTranslation();
  const {
    section,
    dueDateNestingLevel,
    onSetDueDateForSection,
    onSetDueDateForContent,
    nestedDueDateConfig,
    className,
  } = props;
  const onSetSectionDueDate = useCallback(() => {
    onSetDueDateForSection(section, undefined, true);
  }, [onSetDueDateForSection, section]);

  return (
    <Stack className={className}>
      <Stack className="w-full px-36" direction="col">
        <Stack
          alignItems="center"
          className="border-b border-solid border-interactive-border py-16"
          justifyContent="between">
          <SectionDetails section={section} />
          {dueDateNestingLevel === DueDateNestingLevelEnum.Sections ? (
            <RenderDueDate
              selectedDueDate={nestedDueDateConfig?.[section.id]?.dueDateConfig}
              t={t}
              onClick={onSetSectionDueDate}
            />
          ) : null}
        </Stack>
        {section.childResources?.map((childResource, index, arr) => (
          <ChildResource
            key={childResource.id}
            childResource={childResource}
            className={
              index < arr.length - 1 ? 'border-b border-solid border-interactive-border' : ''
            }
            dueDateNestingLevel={dueDateNestingLevel}
            nestedDueDateConfig={nestedDueDateConfig}
            onSetDueDateForContent={onSetDueDateForContent}
          />
        ))}
      </Stack>
    </Stack>
  );
}

export default Section;
